<template>
  <div class="new-slider1">
    <div class="split-text">
      <h1>ΑΦΡΟΔΙΤΗ ΚΑΠΩΝΗ</h1>
      <p>Η Καπώνη Αφροδίτη είναι Νευρολόγος, Διευθύντρια της Α’ Νευρολογικής Κλινικής του Metropolitan General στον Χολαργό.</p>
    </div>
    
    <VueSlickCarousel v-bind="settings" class="slider-new1" >
        <div v-for="(slide,i) in slides" :key="i">
           <div class="car_item">
            <div class="card_vue1" :id="'slide' + i">
            </div>  
          </div>
        </div>
    </VueSlickCarousel>
    <VueSlickCarousel v-bind="settings1" class="slider-new1 slider-right" >
        <div v-for="(slide,i) in slides" :key="i">
           <div class="car_item">
            <div class="card_vue1" :id="'slide' + i">
            </div>  
          </div>
        </div>
    </VueSlickCarousel>
  </div>
   
</template>

<script>
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'


  export default {
    props: ['vertical', 'verticalS', 'items', 'rows','controls'],
    name: 'Carousel_cards',
     components: {
    VueSlickCarousel
  },
    data: () => ({
    settings: {
      "arrows": false,
      "infinite": true,
      "slidesToShow": 1,
      "slidesToScroll": 1,
      "speed": 2000,
      "autoplaySpeed": 3000,
      "autoplay": true,
      "pauseOnFocus": false,
      "pauseOnHover": false,
      "centerMode": false,
      "swipe": false,
      "touchMove": false	
      
    },
    settings1: {
      "arrows": false,
      "infinite": true,
      "slidesToShow": 1,
      "slidesToScroll": 1,
      "speed": 2000,
      "autoplaySpeed": 3000,
      "rtl": true,
      "autoplay": true,
      "pauseOnFocus": false,
      "pauseOnHover": false,
      "centerMode": false,
      "swipe": false,
      "touchMove": false	
    },
    slides: [
      "1",
      "2"
    ]
    })
  }
</script>

<style>
body{
  padding: 0px !important;
  overflow: hidden;
  margin: 0px !important;
}
.slick-track{
  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1) !important;
}
.new-slider1{
  display: flex;
  justify-content: center;
  overflow: hidden;
  
}
  .slider-new1{
    width: 50% !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }
.slider-new1 #slide0{
 
      background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
}
.slider-new1 #slide1{

      background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
}
.slider-right #slide0{

      background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
}
.slider-right #slide1{
      background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
}
.slick-dots{
 position: absolute;
  bottom: 50px;
}
.slick-dots li{
  
  width: 50px;
  height: 50px;
  border-radius: 50px !important;
}
.slick-dots .slick-active{
  background: #ffffff38;
}
.slick-dots .slick-active button:before{
  color: #fff !important;
  opacity: 1 !important;
}
.slick-dots li button:before{
  color: #fff;
  opacity: 1;
  font-size: 13px;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.slick-dots li button{
  width: 50px !important;
  height: 50px !important;
}

  .card_vue1{
    background: #a71d54;
    height: 100vh;
    margin-left: auto;
    margin-right: auto;
    color: #fff;
    background-size: cover;
    position: relative;
    width: 100%;
    
  }


  .slick-slider{
    margin-left: 0px !important;
    margin-right: 0px !important;
    cursor: pointer;
  }
 



@media only screen and (max-width: 1300px) {	
  .new-slider1{
    flex-direction: column !important;
  }
  .slider-new1{
    width: 100% !important;
  }
    .card_vue1{
      background: #a71d54;
      height: 50vh;
      margin-bottom: 0px !important;
    }
}
@media only screen and (max-width: 600px) {	
    .card_vue1{
      background: #a71d54;
      height: 30vh;
      margin-bottom: 0px !important;
    }
}
</style>